import { DialogStyled } from "@/components/DialogStyled";
import { MusicResultTable } from "@/components/MusicResultTable";
import { SharePlaylistButton } from "@/components/playlist/SharePlaylistButton";
import { nextTrackState, playerPlaylistState } from "@/context/states";
import theme from "@/styles/theme";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";
import dynamic from "next/dynamic";
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";

const ModalSharePlaylist = dynamic(() =>
  import("@/components/ModalSharePlaylist"),
);

export const PlaylistSuchenResults = ({ playlist, filter }) => {
  const [nextTrack, setNextTrack] = useRecoilState(nextTrackState);
  const [playerPlaylist, setPlayerPlaylist] =
    useRecoilState(playerPlaylistState);
  const [tracks, setTracks] = useState(playlist.songs);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalClosed = () => setIsModalOpen(false);
  const [urlPlaylist] = useState(
    `${location.protocol}//${location.host}/playlist/${playlist.slug}`,
  );

  const [viewType, setViewType] = React.useState("list");

  useEffect(() => {
    setTracks(playlist.songs);
  }, [playlist]);

  useEffect(() => {
    if (!filter || filter.length == 0) {
      setTracks(playlist?.songs);
      return;
    }

    const regexFilter = new RegExp(filter, "i");

    setTracks(
      playlist.songs.filter((song) => {
        if (song.title.match(regexFilter)) {
          return true;
        }
        if (song.band.name.match(regexFilter)) {
          return true;
        }
        if (song.genre.title.match(regexFilter)) {
          return true;
        }

        return false;
      }),
    );
  }, [filter]);

  const enableView = (type) => {
    setViewType(type);
  };

  const handlePlaySong = (song) => {
    setPlayerPlaylist(tracks);
    setNextTrack(song);
  };

  const handleModalOpen = async () => {
    setIsModalOpen(true);
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sx={{ [theme.breakpoints.up("sm")]: { mb: "-11px" } }}>
        <Typography
          variant="h4"
          sx={{
            display: { xs: "none", sm: "block" },
            mb: 1,
          }}
        >
          Songs
        </Typography>
        <Grid
          container
          alignItems="center"
          sx={{
            [theme.breakpoints.up("sm")]: {
              mt: "-.625rem",
            },
          }}
        >
          <Grid item xs={7} sm={5}>
            <Typography
              variant="caption"
              sx={{
                textTransform: "uppercase",
                color: grey[600],
              }}
            >
              {tracks?.length} Songs gefunden
            </Typography>
          </Grid>
          <Grid item xs={5} sm={7}>
            <Grid
              container
              justifyContent="flex-end"
              alignItems="flex-end"
              sx={{ height: "100%" }}
            >
              <Grid item>
                <Stack
                  direction="row"
                  spacing={{ sm: 0.5 }}
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 40,
                    },
                    "& .MuiButtonBase-root": {
                      p: 0,
                      borderRadius: "0",
                    },
                    [theme.breakpoints.up("sm")]: {
                      transform: "translateY(-.5rem)",
                    },
                  }}
                >
                  <SharePlaylistButton onClick={handleModalOpen} />
                  <DialogStyled
                    open={isModalOpen}
                    onClose={handleModalClosed}
                    disableCloseOnBackgroundClick
                    fullScreen
                  >
                    <ModalSharePlaylist
                      urlPlaylist={urlPlaylist}
                      playlist={playlist}
                    />
                  </DialogStyled>
                  <IconButton
                    aria-label="Listenansicht"
                    onClick={() => enableView("list")}
                    variant={viewType == "list" ? "active" : "inactive"}
                  >
                    <ViewListIcon />
                  </IconButton>
                  <IconButton
                    aria-label="Kachelansicht"
                    onClick={() => enableView("grid")}
                    variant={viewType == "grid" ? "active" : "inactive"}
                  >
                    <ViewModuleIcon />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <MusicResultTable
        viewType={viewType}
        songs={tracks}
        onPlaySong={handlePlaySong}
      />
    </Grid>
  );
};
